const group = <T>(_name: string, cb: () => T) => cb();

export { group };
